import React, { useEffect, useState } from "react";

import useSiteSettings, { resolveSiteLogo } from "@/hooks/useSiteSettings";
import Image from "../../../assets/images/IMAGE.jpg";
import AnonymousRegister from "../../LoginAndRgister/AnonymousRegister";
import Login from "../../LoginAndRgister/Login";
import Register from "../../LoginAndRgister/Register";
import Modal from "../../Modals/Modal";
import { StyledRegisterModal } from "./StyledRegisterModal";

const isAnonymousSignupEnabled = (settings = {}) =>
  Boolean(
    settings.domainSettings?.anonymous_signup_enabled ??
      settings.domain_settings?.anonymous_signup_enabled ??
      settings.anonymous_signup_enabled
  );

const RegisterModal = ({ buttonText, modalOption }) => {
  const [showModal, setShowModal] = useState(false);
  const [openedModal, setOpenedModal] = useState(modalOption);
  const { settings } = useSiteSettings();
  const backendLogo = resolveSiteLogo(settings);
  const canUseAnonymousSignup = isAnonymousSignupEnabled(settings);
  const activeModal = openedModal === "anonymous" && !canUseAnonymousSignup ? "register" : openedModal;

  const openRegisterModal = (option) => {
    setShowModal(true);
    setOpenedModal(option);
  };

  const closeModal = () => setShowModal(false);

  useEffect(() => {
    if (modalOption !== "login") return undefined;

    const handleAuthRequired = (event) => {
      setShowModal(true);
      setOpenedModal(event?.detail?.modalOption || "login");
    };

    window.addEventListener("crypto-auth-required", handleAuthRequired);
    return () => {
      window.removeEventListener("crypto-auth-required", handleAuthRequired);
    };
  }, [modalOption]);

  if (modalOption === "anonymous" && !canUseAnonymousSignup) return null;

  return (
    <StyledRegisterModal>
      {modalOption === "login" ? (
        <button
          type="button"
          onClick={() => openRegisterModal("login")}
          className="auth-header-button auth-header-login"
        >
          {buttonText ?? modalOption}
        </button>
      ) : modalOption === "anonymous" ? (
        <button
          type="button"
          onClick={() => openRegisterModal("anonymous")}
          className="auth-header-button auth-header-anonymous"
        >
          {buttonText ?? modalOption}
        </button>
      ) : (
        <button
          type="button"
          onClick={() => openRegisterModal("register")}
          className="auth-header-button auth-header-register"
        >
          {buttonText ?? modalOption}
        </button>
      )}

      <Modal
        maxWidth={1040}
        isOpen={showModal}
        onClose={closeModal}
        panelClassName="auth-dialog-panel"
      >
        <StyledRegisterModal>
          <div className={`auth-modal-shell is-${activeModal}`}>
            <section className="auth-form-panel">
              <div className="auth-tab-row" role="tablist" aria-label="인증 방식">
                <button
                  type="button"
                  className={`auth-tab ${activeModal === "login" ? "active" : ""}`}
                  onClick={() => setOpenedModal("login")}
                  aria-pressed={activeModal === "login"}
                >
                  로그인
                </button>
                <button
                  type="button"
                  className={`auth-tab ${activeModal === "register" ? "active" : ""}`}
                  onClick={() => setOpenedModal("register")}
                  aria-pressed={activeModal === "register"}
                >
                  회원가입
                </button>
                {canUseAnonymousSignup ? (
                  <button
                    type="button"
                    className={`auth-tab ${activeModal === "anonymous" ? "active" : ""}`}
                    onClick={() => setOpenedModal("anonymous")}
                    aria-pressed={activeModal === "anonymous"}
                  >
                    무기명가입
                  </button>
                ) : null}
              </div>

              <div key={activeModal} className="auth-form-transition">
                {activeModal === "login" ? (
                  <Login onSuccess={closeModal} />
                ) : activeModal === "anonymous" ? (
                  <AnonymousRegister
                    onSuccess={closeModal}
                    onSwitchToLogin={() => setOpenedModal("login")}
                  />
                ) : (
                  <Register
                    onSuccess={closeModal}
                    onSwitchToLogin={() => setOpenedModal("login")}
                  />
                )}
              </div>
            </section>

            <aside className="auth-visual-panel">
              <button type="button" className="auth-close-button" onClick={closeModal} aria-label="닫기">
                <span aria-hidden="true" />
              </button>

              {backendLogo ? (
                <img src={backendLogo} className="auth-brand-logo" alt="site logo" />
              ) : null}

              <img src={Image} className="auth-visual-image" alt="" aria-hidden="true" />
              <div className="auth-visual-overlay" />
              <div className="auth-visual-copy">
                <strong>안전한 회원 인증</strong>
                <span>계정 정보를 확인하고 빠르게 게임 로비로 이동하세요.</span>
                <p>만 18세 이상이며 서비스 이용 조건을 확인했습니다.</p>
              </div>
            </aside>
          </div>
        </StyledRegisterModal>
      </Modal>
    </StyledRegisterModal>
  );
};

export default RegisterModal;
